import objectAssign from 'object-assign';
import initialState from './initialState';
import {
  FETCH_USER_DATA,
  RECEIVE_USER_DATA,
  CLEAR_USER_DATA
} from '../actions/actionTypes';
import { trackUser } from '@forwardfinancing/analytics-frontend-library/index';
import { initializePendo } from '../lib/pendo';

export default function userData(state = initialState.user, action) {
  let newState;

  switch (action.type) {
    case FETCH_USER_DATA:
      return action;
    case RECEIVE_USER_DATA:
      newState = objectAssign({}, state);
      newState = action.user;
      // Setup mixpanel with new user data
      trackUser(newState);
      // Initialize Pendo after successful login/user load
      initializePendo(newState);
      return newState;
    case CLEAR_USER_DATA:
      return initialState.user;
    default:
      return state;
  }
}
